import { Directive, ElementRef, Renderer2, AfterViewInit } from '@angular/core';

@Directive({
  selector: '[appModifyAnchorLinks]'
})
export class ModifyAnchorLinksDirective implements AfterViewInit {

  private observer!: MutationObserver;
  constructor(private el: ElementRef, private renderer: Renderer2) {}
  private anchorLinkSelector = `a[href^="#"]:not([modified-anchor-link])`;

  ngAfterViewInit() {
    this.modifyLinks();
    this.observeDomChanges();
  }

  ngOnDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  private modifyLinks(nodes?: HTMLElement[]) {
    // Use the provided nodes or query for the default set of links
    const links = nodes ?? Array.from(
      this.el.nativeElement.parentElement.querySelectorAll(this.anchorLinkSelector)
    );

    links.forEach((link: HTMLElement) => {
      const anchorId = link.getAttribute('href')?.substring(1)!;
      const modifiedAttrExist = link.hasAttribute('modified-anchor-link');
      if(!anchorId || modifiedAttrExist) return;

      link.addEventListener("click", (event) => {
        event.preventDefault();
        this.scrollToElement(anchorId);
      })
      this.renderer.setAttribute(link, 'modified-anchor-link', '');
    });
  }

  private scrollToElement(id: string) {
    if (!id) return;
    id = id.charAt(0).toLowerCase() + id.slice(1);
    const blocklist = document.querySelector(`[blocklist-id="${id}"]`);
    if(blocklist)
      blocklist.scrollIntoView({behavior: 'smooth'})
  }

  private observeDomChanges() {
    const observer = new MutationObserver((mutations) => {
      const addedLinks: HTMLElement[] = [];
  
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if ((node as HTMLElement).matches?.(this.anchorLinkSelector)) {
            // If the node itself is a link
            addedLinks.push(node as HTMLElement);
          } else if ((node as HTMLElement).querySelectorAll) {
            // If the node contains links, query them and cast to HTMLElement
            addedLinks.push(
              ...Array.from(
                (node as HTMLElement).querySelectorAll(this.anchorLinkSelector)
              ).map((el) => el as HTMLElement)
            );
          }
        });
      });

      if (addedLinks.length > 0) {
        // Ensure addedLinks contains only distinct elements
        const distinctLinks = Array.from(new Set(addedLinks));

        this.modifyLinks(distinctLinks); // Pass only the collected links
      }
    });
  
    observer.observe(this.el.nativeElement.parentElement, {
      childList: true,
      subtree: true,
    });
  }
}
